@if ((account$ | async)?.capabilities?.includes(ECapabilities.ADMINISTRATIVE_DOCUMENTS)) {
  @if ((invoices$ | async).length > 0) {
    <h2>
      @if (type === EInvoiceType.PURCHASE) {
        Facturas (transportista)
      } @else if (type === EInvoiceType.SALE) {
        Facturas (cargador)
      }
    </h2>
    <div class="block-content-round ion-padding-horizontal-0">
      <ion-list>
        <ion-item-group>
          <ion-item-divider
            sticky
            class="ion-hide-lg-down"
          >
            <ion-grid>
              <ion-row>
                <ion-col
                  class="ion-align-self-top"
                  size="6"
                  sizeLg="6"
                  sizeXl="4"
                >
                  <ion-row>
                    <ion-col
                      class="ion-text-start"
                      size="12"
                      sizeLg="4"
                    >
                      <p>Fecha</p>
                    </ion-col>
                    <ion-col
                      class="ion-text-start"
                      size="12"
                      sizeLg="8"
                    >
                      <p>Nº fra.</p>
                    </ion-col>
                  </ion-row>
                </ion-col>

                <ion-col
                  class="ion-align-self-top"
                  size="6"
                  sizeLg="6"
                  sizeXl="4"
                >
                  <ion-row>
                    <ion-col
                      class="ion-text-end"
                      size="12"
                      sizeLg="4"
                    >
                      <p>Importe</p>
                    </ion-col>
                    <ion-col
                      class="ion-text-end"
                      size="12"
                      sizeLg="4"
                    >
                      <p>IVA</p>
                    </ion-col>
                    <ion-col
                      class="ion-text-end"
                      size="12"
                      sizeLg="4"
                    >
                      <p>Total</p>
                    </ion-col>
                  </ion-row>
                </ion-col>

                <ion-col
                  class="ion-align-self-top ion-hide-xl-down"
                  size="6"
                  sizeLg="2"
                >
                  <ion-row>
                    <ion-col
                      class="ion-text-end"
                      size="12"
                      sizeLg="6"
                    >
                      <p>Vencimiento</p>
                    </ion-col>
                    <ion-col
                      class="ion-text-end"
                      size="12"
                      sizeLg="6"
                    >
                      <p>Estado</p>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item-divider>

          @for (invoice of invoices$ | async; track invoice.id) {
            <ion-item>
              <ion-label>
                <ion-grid>
                  <ion-row class="ion-align-items-start ion-align-items-lg-center">
                    <ion-col
                      class="ion-align-self-top"
                      size="6"
                      sizeXl="4"
                      sizeLg="6"
                    >
                      <ion-row>
                        <ion-col
                          class="ion-text-start"
                          size="12"
                          sizeLg="4"
                        >
                          <p>
                            {{ invoice.date | dfnsFormat: 'P' }}
                          </p>
                        </ion-col>
                        <ion-col
                          class="ion-text-start"
                          size="12"
                          sizeLg="8"
                        >
                          <p>
                            <strong>{{ invoice.name }}</strong>
                          </p>
                        </ion-col>
                      </ion-row>
                    </ion-col>

                    <ion-col
                      class="ion-align-self-top"
                      size="6"
                      sizeXl="4"
                      sizeLg="6"
                    >
                      <ion-row>
                        <ion-col
                          class="ion-text-end"
                          size="12"
                          sizeLg="4"
                        >
                          <p>
                            {{ invoice.amountUntaxed | currency: 'EUR' : 'symbol' : '1.2-2' }}
                          </p>
                        </ion-col>
                        <ion-col
                          class="ion-text-end"
                          size="12"
                          sizeLg="4"
                        >
                          <p>
                            {{ invoice.amountTax | currency: 'EUR' : 'symbol' : '1.2-2' }}
                          </p>
                        </ion-col>
                        <ion-col
                          class="ion-text-end"
                          size="12"
                          sizeLg="4"
                        >
                          <p>
                            {{ invoice.amountTotal | currency: 'EUR' : 'symbol' : '1.2-2' }}
                          </p>
                        </ion-col>
                      </ion-row>
                    </ion-col>

                    <ion-col
                      class="ion-align-self-top"
                      size="6"
                      sizeXl="2"
                      sizeLg="8"
                    >
                      <ion-row>
                        <ion-col
                          class="ion-text-start ion-text-xl-end"
                          size="12"
                          sizeLg="6"
                        >
                          <p class="datedue">
                            <span class="ion-hide-xl-up">Ventimiento:</span>
                            {{ invoice.dateDue | dfnsFormat: 'P' }}
                          </p>
                        </ion-col>
                        <ion-col
                          class="ion-text-start ion-text-xl-end"
                          size="12"
                          sizeLg="6"
                        >
                          <p>
                            <span
                              class="invoice-state"
                              [ngClass]="{
                                paid: EInvoiceState.PAID === invoice.state,
                                unpaid: EInvoiceState.NOT_PAID === invoice.state,
                                inprogress: EInvoiceState.IN_PAYMENT === invoice.state,
                              }"
                            >
                              {{ 'EInvoiceState.' + invoice.state | translate }}
                            </span>
                          </p>
                        </ion-col>
                      </ion-row>
                    </ion-col>

                    <ion-col
                      class="ion-align-self-top ion-text-end"
                      size="6"
                      sizeXl="2"
                      sizeLg="4"
                    >
                      @if (invoice.downloadUrl) {
                        <ion-button
                          fill="outline"
                          size="small"
                          (click)="download(invoice.downloadUrl)"
                        >
                          <ion-icon
                            src="../assets/material-symbols/okcargo-download_pdf.svg"
                            slot="start"
                          ></ion-icon>
                          {{ 'general.download' | translate }}
                        </ion-button>
                      }
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-label>
            </ion-item>
          }
        </ion-item-group>
      </ion-list>
    </div>
  }
}
